import { useEffect } from "react";
import { getRoles } from "../Reducers/getRoles";

export function useGetRoles(dispatch) {
  useEffect(() => {
    dispatch(getRoles({ skip: 0, limit: 1000, order: "", orderBy: "name", search: "" }));
  }, [dispatch]);
}
